<template>
  <CellGroup>
    <Cell v-for="(item,index) in List" :key="index" use-label-slot :border="false">
      <mVideo :videoUrl="item.mediaurl" height="4rem" fit="cover" v-if="+item.sportsItem.type!==5" />
      <!-- <div slot="label">
              {{item.sportsItemSub.title}}
      </div>-->
      <Cell
        :title="item.sportsItemSub.title"
        use-label-slot
        style="border:1px solid #f4f4f4;padding:10px;"
      >
        <div slot="label" style="display:flex;align-items:center;justify-content:space-between;">
          {{item.create_time}}
           <a
              style="color:#15BBEA"
             v-if="item.cert"
              :href="item.cert"
            >证书下载</a>
            <span style="color:#15BBEA" v-if="item.sports_item_sub_id == 2591 || item.sports_item_sub_id == 2591 || item.sports_item_sub_id == 2592 || item.sports_item_sub_id == 2593 || item.sports_item_sub_id == 2594 || item.sports_item_sub_id == 2595|| item.sports_item_sub_id == 2761|| item.sports_item_sub_id == 2762|| item.sports_item_sub_id == 2763">
              成绩：{{item.score}}
            </span>
        </div>
      </Cell>
    </Cell>
  </CellGroup>
</template>
<script>
import { Popup, Tab, Tabs, Cell, CellGroup, Button } from "vant";
import mVideo from "@/components/mVideo/index";
import "./index.less";

export default {
  name: "myvotes",
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    vanPopup: Popup,
    mVideo,
    Cell,
    CellGroup,
    Button,
  },
  props: {
    List: Array,
  },
  data() {
    return {};
  },
  methods: {
    gotouch(item) {
      this.$emit("gotouch", item);
    },
  },
};
</script>
